var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VARIANT_WITH_PRODUCT_FRAGMENT = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const variantFragment_1 = require("./variantFragment");
exports.VARIANT_WITH_PRODUCT_FRAGMENT = (0, graphql_tag_1.default) `
  fragment VariantWithProductFragment on ProductVariant {
    ...VariantFragment
    product {
      description
      handle
      id
      productType
      tags
      vendor
    }
  }
  ${variantFragment_1.VARIANT_FRAGMENT}
`;
//# sourceMappingURL=variantWithProductFragment.js.map